// extracted by mini-css-extract-plugin
export default {"backButton":"back-arrow-module__backButton____y_db"};